import React from 'react';
import { Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { withStyles } from '@material-ui/core/styles';

const StyledTooltip = withStyles({
    tooltip: {
        backgroundColor: 'rgba(200, 200, 200, 1)',
        color: 'rgba(0, 0, 0, 1)',
        border: '1px solid black',
        fontSize: 16,
        whiteSpace: 'pre-wrap',
        maxWidth: 500,
    }
})(Tooltip);

const styles = () => ({
    my_auto: {
        marginBottom: '-5px',
        marginLeft: '5px'
    },
    cursorHelp:{
        cursor: 'help',
    },
});

const HelpToolTip = (props) => {
    const { classes, infoText } = props;
    return (
        <StyledTooltip title={infoText} arrow placement="top">
            <HelpIcon className={classes.my_auto + ' ' + classes.cursorHelp}/>
        </StyledTooltip>
    )
}

export default withStyles(styles)(HelpToolTip);